import React from 'react';
import { ButtonLink } from '../../core';
import { useParams, useLocation } from 'react-router-dom';
import { getVaultPath } from '../../../utils';

interface VaultPageTabProps {
  match: boolean;
  label: string;
  value: string | undefined;
}

export const VaultPageTab = ({
  match,
  label,
  value,
}: VaultPageTabProps): JSX.Element => {
  const { vaultAddress, vaultType } = useParams();
  const { search } = useLocation();
  return (
    <ButtonLink
      mr={3}
      variant={match ? 'buttons.tab' : 'buttons.tabFaded'}
      sx={{ textTransform: 'capitalize' }}
      to={() => ({
        pathname: getVaultPath(vaultAddress, vaultType, value),
        search,
      })}
    >
      {label}
    </ButtonLink>
  );
};
